import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Hospital, MessageSquare, Zap, Check } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen flex flex-col vitra-atmosphere">
      <Header />
      <main className="flex-grow w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">About VITRA</h1>
          <p className="text-xl text-gray-600">Remote Patient Monitoring Made Simple</p>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Mission</h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            VITRA is dedicated to revolutionizing remote patient monitoring and healthcare management.
            We empower healthcare professionals with intuitive tools to monitor, manage, and care for their patients
            from anywhere, at any time.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            Our platform bridges the gap between patients and clinicians, enabling real-time communication,
            comprehensive health tracking, and data-driven clinical decisions.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-teal-50 text-teal-700">
              <Hospital className="w-6 h-6" strokeWidth={1.75} />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Healthcare Focused</h3>
            <p className="text-gray-700">Built specifically for healthcare professionals and clinicians.</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-teal-50 text-teal-700">
              <MessageSquare className="w-6 h-6" strokeWidth={1.75} />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Communication made Easy</h3>
            <p className="text-gray-700">Online messaging and communication with patients.</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-teal-50 text-teal-700">
              <Zap className="w-6 h-6" strokeWidth={1.75} />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Real-Time Monitoring</h3>
            <p className="text-gray-700">Instant alerts and live monitoring capabilities.</p>
          </div>
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-8 border border-teal-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Why Choose VITRA?</h2>
          <ul className="space-y-3 text-lg text-gray-700">
            {[
              'Intuitive interface designed for healthcare professionals',
              'Real-time patient monitoring and alert system',
              'Comprehensive appointment and medication management',
              'Messaging and patient communication',
              'Advanced analytics and reporting dashboards',
            ].map((item) => (
              <li key={item} className="flex items-start gap-3">
                <Check className="w-5 h-5 text-teal-600 mt-1 flex-shrink-0" strokeWidth={2.5} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
